module.exports = __webpack_public_path__ + "img/attachmentSetting-1.23670b6.png";